// extracted by mini-css-extract-plugin
export default {"root":"ReportsPage_root__RgGvA","loaderWrapper":"ReportsPage_loaderWrapper__8bjHy"};